import { TEMPLATE_TYPES } from 'components/templates/shared/constants';

import messages from 'components/templates/shared/messages';

export const formatTemplates = ({ templates, type }) => {
  const formattedTemplates = templates.map((template) => {
    switch (type) {
      case TEMPLATE_TYPES.REPORT_TEMPLATE:
        return {
          ...template,
          name: template.title,
          editLink: `/templates/reports/${template.id}/edit`,
        };
      case TEMPLATE_TYPES.TASK_LIST_TEMPLATE:
        return {
          ...template,
          name: template.name,
          editLink: `/todos/templates/edit/${template.id}`,
        };
      case TEMPLATE_TYPES.PROJECT_BLUEPRINT:
        return {
          ...template,
          name: template.title,
          editLink: `/templates/projects/${template.databaseId}/edit`,
          defaultMessage: template.default
            ? messages.unsetDefaultProjectTemplate
            : messages.setDefaultProjectTemplate,
        };

      case TEMPLATE_TYPES.COMPANY_DOCUMENT:
        return {
          ...template,
          name: template.name,
          editLink: `/templates/documents/${template.databaseId}`,
        };
      case TEMPLATE_TYPES.PAGE_TEMPLATE:
        return {
          ...template,
          name: template.title || 'Untitled',
          editLink: `/templates/pages/${template.id}/edit`,
        };
      default:
        return template;
    }
  });

  return formattedTemplates;
};
